import { DeliveryFilled } from 'jl-design-system/components/icons/DeliveryFilled';
import { DeliveryOutlined } from 'jl-design-system/components/icons/DeliveryOutlined';
import { InStoreOutlined } from 'jl-design-system/components/icons/InStoreOutlined';
import { InStoreFilled } from 'jl-design-system/components/icons/InStoreFilled';

// Config
import deliveryConstants from '@constants/deliveryConstants';
import { CLICK_AND_COLLECT_MIN_VALUE } from '@constants/clickCollectConstants';
import { freeDeliveryThresholds } from '@constants/deliveryConstants';

export const getIcon = (deliveryId = '', isSelected = false) => {
  const deliveryIcon = isSelected ? DeliveryFilled : DeliveryOutlined;
  const collectionIcon = isSelected ? InStoreFilled : InStoreOutlined;
  const Icon = deliveryId === deliveryConstants.DELIVERY ? deliveryIcon : collectionIcon;

  return Icon;
};

export const getTabTitleWithCostInfo = (basketTotalValue = '', deliveryId = '', minimal = false, isDeliveryThresholdIncreaseEnabled = false) => {
  let cost;

  const { FREE_DELIVERY_50, FREE_DELIVERY_70 } = freeDeliveryThresholds;

  const basketCostRange = {
    min: CLICK_AND_COLLECT_MIN_VALUE,
    max: isDeliveryThresholdIncreaseEnabled ? FREE_DELIVERY_70 : FREE_DELIVERY_50,
  };

  const COLLECTION_COST_INFO = 'from £2.95';
  const DELIVERY_COST_INFO = 'from £4.50';
  const FREE_COLLECTION = minimal ? 'Free' : 'Free\ncollection';
  const FREE_STANDARD_DELIVERY = minimal ? 'Free' : 'Free standard\nUK delivery';

  const isClickAndCollectTab = deliveryId === deliveryConstants.CLICK_AND_COLLECT;

  const basketTotalValueNumber = Number(basketTotalValue);

  if (basketTotalValueNumber < basketCostRange.min) {
    cost = isClickAndCollectTab ? COLLECTION_COST_INFO : DELIVERY_COST_INFO;
  } else if ((basketTotalValueNumber >= basketCostRange.min) && (basketTotalValueNumber < basketCostRange.max)) {
    cost = isClickAndCollectTab ? FREE_COLLECTION : DELIVERY_COST_INFO;
  } else if (basketTotalValueNumber >= basketCostRange.max) {
    cost = isClickAndCollectTab ? FREE_COLLECTION : FREE_STANDARD_DELIVERY;
  }

  return cost;
};
